import React from 'react';
import './UpdatePhoto.css';
import Select from 'react-select';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCheckbox} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';

/**
 * La vue qui permet d'ajouter des médias
 * @param {*} props props
 * @return {JSX}
 */
function UpdatePhotoView(props) {
  const handleToggle = () => {
    props.setChecked(!props.checked);

    props.setForm({
      ...props.form,
      factureNameForm: null,
      montant: null,
    });
  };

  return (
    <div className="banktable-container">

      <MDBContainer fluid >
        <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
          <MDBCol col="12">
            <MDBCard className="bg-dark text-white my-2 mx-auto align-items-center"
              style={{borderRadius: '1rem', maxWidth: '800px'}}>
              <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>Modifier la {props.type ? 'facture' : 'photo'}</h2>
              <MDBCardBody className="mx-auto w-100 addInfo-padding">
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <button
                    type="button"
                    style={{fontSize: '20px', backgroundColor: '#212529', color: 'white'}}
                    onClick={() => props.handleDelete()}>
                    <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                  </button>
                  <span
                    onClick={() => props.closeModal()}
                    style={{fontSize: '35px', cursor: 'pointer'}}>&times;</span>
                </div>
                <div className="app" style={{textAlign: 'center'}}>
                  <LazyLoadImage
                    src={props.form.url}
                    alt="error"
                    className="chantierheure-photo"
                    placeholderSrc="/images/notloaded.png"
                    effect="blur" />
                </div>
                <div style={{marginTop: '28px'}}>
                  <input
                    className="form-control"
                    type="date"
                    name="selectedDate"
                    defaultValue={props.form.selectedDate}
                    onChange={props.handleChangeValue}
                    style={{
                      fontSize: '18px',
                      color: 'black',
                      fontWeight: '450',
                    }} />
                </div>
                <div style={{marginTop: '22px'}}>
                  <MDBCheckbox name='extra1' id='inlineCheckbox11111' defaultChecked={props.form.extra1} label='Extra possible' onChange={props.handleChangeCheckbox} inline />
                  {localStorage.getItem('admin') === '1' ?
                  <React.Fragment>
                    <MDBCheckbox name='extra2' id='inlineCheckbox22222' defaultChecked={props.form.extra2} label='Extra valider' onChange={props.handleChangeCheckbox} inline />
                    <MDBCheckbox name='extra3' id='inlineCheckbox33333' defaultChecked={props.form.extra3} label='Extra confirmer' onChange={props.handleChangeCheckbox} inline />
                  </React.Fragment> : '' }
                  <MDBCheckbox name='avancement' id='inlineCheckbox44444' defaultChecked={props.form.avancement} label='Avancement' onChange={props.handleChangeCheckbox} inline />
                </div>
                <div className="app" style={{textAlign: 'center', marginTop: '25px'}}>
                  <label className="labelFacture">Facture ?</label>
                  <div className="toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle2"
                        type="checkbox"
                        checked={props.checked}
                        onChange={handleToggle} />
                      <label htmlFor="toggle2"></label>
                    </div>
                  </div>

                  {props.checked && (
                    <>
                      <div style={{marginTop: '18px'}}>
                        <Select
                          name="factureNameForm"
                          options={props.factureName}
                          value={props.form.factureNameForm}
                          onChange={props.handleFactureNameFormChange}
                          className="form-control addcheckin-form-control-padding"
                          placeholder="Factures" />
                      </div>
                      <div className="form-group mt-2" >
                        <input
                          style={{marginTop: '15px', marginBottom: '7px'}}
                          type="text"
                          name="montant"
                          defaultValue={props.form.montant}
                          onChange={props.handleChangeValue}
                          className="form-control"
                          placeholder="montant" />
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <textarea
                    type="text"
                    name="note"
                    defaultValue={props.form.note}
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Note" />
                </div>
                <Button
                  color="white"
                  size="lg"
                  style={{
                    color: 'white',
                    fontSize: 'calc(10px + 2vmin)',
                    backgroundColor: '#363E46',
                    border: 'none',
                    width: '100%',
                    marginTop: '15px',
                  }}
                  onClick={props.handleSubmit}>
                  Enregistrer
                </Button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default UpdatePhotoView;
